import React from 'react';
import { Dropdown } from 'primereact/dropdown';

import { useFileManagerContext } from 'modules/file_manager/context/FileManagerContext';

function ReadStatusFilter() {
  const { fileManagerFilters, onFilterChange, setSelectedRows } = useFileManagerContext();

  const readStatusOptions = [
    { label: 'Read', value: true },
    { label: 'Unread', value: false },
  ];

  return (
    <>
      <div className="d-flex flex-column filter-wraper">
        <Dropdown
          options={readStatusOptions}
          value={fileManagerFilters?.is_read}
          placeholder="By Read Status"
          className="file-manager-select"
          onChange={(e) => {
            onFilterChange({
              target: { name: 'is_read', value: e.value },
              value: e.value,
            });
            setSelectedRows([]);
          }}
          name="is_read"
        />
      </div>
    </>
  );
}

export default ReadStatusFilter;
